import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Box, debounce, Icon, Tooltip, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useLayoutEffect, useState } from "react";
export const SymbolFlags = ({ symbolFlags, maxSymbols, onSeeMoreClick, style }) => {
    const [maxSymbolsCalculated, setMaxSymbolsCalculated] = useState(maxSymbols);
    useLayoutEffect(() => {
        let isMounted = true;
        const symbolFlagsWraps = document.querySelectorAll(".symbol-flags");
        const handleResize = debounce((entries) => {
            try {
                if (isMounted) {
                    entries.forEach((entry) => {
                        const documentRemToPxValue = parseFloat(getComputedStyle(document.documentElement).fontSize);
                        const dimensionIntValue = parseInt(dimension.replace("rem", ""));
                        const dimensionPxValue = documentRemToPxValue * dimensionIntValue + 2;
                        const { width } = entry.contentRect;
                        setMaxSymbolsCalculated(Math.floor(width / dimensionPxValue));
                    });
                }
            }
            catch (error) {
                console.error("Error in Symbol Flag ResizeObserver callback:", error);
            }
        }, 50);
        const symbolWrapObserver = new ResizeObserver(handleResize);
        if (symbolFlagsWraps.length) {
            symbolFlagsWraps.forEach((symbolFlagsWrap) => {
                symbolWrapObserver.observe(symbolFlagsWrap);
            });
        }
        return () => {
            isMounted = false;
            symbolWrapObserver.disconnect();
        };
    }, []);
    const dimension = "2rem";
    const enforceMax = symbolFlags && symbolFlags.length > maxSymbolsCalculated;
    let reachedMax = false;
    return (_jsx(_Fragment, { children: _jsx(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "left", flexWrap: "wrap", width: "100%", maxHeight: dimension, overflow: "hidden", style: Object.assign({}, style), className: "symbol-flags" }, { children: symbolFlags
                .sort((a, b) => a.Sequence - b.Sequence)
                .map((symbol, index) => {
                if (reachedMax) {
                    return;
                }
                const sybolIsDuotone = symbol.Icon.includes("fad");
                const elemKey = `${symbol.FlagName}-${symbol.FlagValue}`;
                const sharedStyles = {
                    height: dimension,
                    width: dimension,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    marginRight: "2px",
                };
                if (enforceMax && index == maxSymbolsCalculated - 1) {
                    const remainingSymbols = symbolFlags.length - maxSymbolsCalculated + 1;
                    reachedMax = true;
                    return (_jsxs(Box, Object.assign({ onClick: onSeeMoreClick, style: Object.assign(Object.assign({}, sharedStyles), { backgroundColor: "rgba(128,128,128,.2)", cursor: "pointer" }) }, { children: ["+", remainingSymbols] }), elemKey));
                }
                else {
                    return (_jsx(Tooltip, Object.assign({ title: symbol.Description }, { children: _jsx(Avatar, Object.assign({ sx: Object.assign(Object.assign({}, sharedStyles), { backgroundColor: symbol.Color, color: symbol.IconColor }) }, { children: symbol.Icon ? (_jsx(Icon, { className: symbol.Icon, sx: Object.assign({ fontSize: "1rem", overflow: "visible" }, (sybolIsDuotone &&
                                    symbol.DuotoneColor && {
                                    "&:after": {
                                        opacity: "1!important",
                                        color: `${symbol.DuotoneColor}!important`,
                                    },
                                })) })) : (_jsx(Typography, Object.assign({ variant: "body2", sx: {
                                    fontWeight: "bold",
                                    lineHeight: 1,
                                    fontSize: ".6rem",
                                } }, { children: symbol.Abbreviation }))) })) }), elemKey));
                }
            }) })) }));
};
